import Alumni from "../components/pages/Alumni";

export default Alumni;
